import { getToiawaseList } from "@/api/toiawase.api";
import { DatePattern } from "@/constants/common.constant";
import { ErrorMsg } from "@/constants/message.constant";
import { QueryToiawase } from "@/interfaces/toiawase.interface";
import { dateFormat } from "@/utils/date";
import dayjs from "dayjs";
import { ElMessage } from "element-plus";
import { ref } from "vue";
import { Prop2LabelMap, ToiawaseInfo } from "./config";

// excel出力
export function export2Excel(queryForm: QueryToiawase) {
  const exportLoading = ref(false);
  const handleExport2excel = async () => {
    try {
      exportLoading.value = true;
      await generateExcel(queryForm);
    } catch (error) {
      ElMessage.error(ErrorMsg.ERR_EXPORT_FAIL);
    } finally {
      exportLoading.value = false;
    }
  };
  return {
    exportLoading,
    handleExport2excel,
  };
}

async function generateExcel(queryForm: QueryToiawase) {
  const { data } = await getToiawaseList({
    toiawaseJokyoCd: queryForm.toiawaseJokyoCd,
    kjnNm: queryForm.kjnNm,
    kaishaNm: queryForm.kaishaNm,
    page: 0,
    limit: 0,
  });
  const { listData } = data.result;
  const list: ToiawaseInfo[] = [];
  for (let i = 0; i < listData.length; i++) {
    list.push({
      id: listData[i].id,
      toiawaseId: listData[i].toiawase_id,
      toiawaseJokyoCd: listData[i].jokyo.toiawase_jokyo_cd,
      toiawaseJokyo: listData[i].jokyo.toiawase_jokyo,
      createdDate: dateFormat(listData[i].toroku_date),
      kjnNm: listData[i].kjn_nm,
      kaishaNm: listData[i].kaisha_nm,
      email: listData[i].mail_address,
      toiawaseKenmei: listData[i].toiawase_kenmei,
      toiawaseNaiyo: listData[i].toiawase_naiyo,
      kaitoNaiyo: listData[i].kaito_naiyo,
      accountId: listData[i].tanto_shoninsha?.account.akaunto_id,
      tantoNm: listData[i].tanto_shoninsha?.tanto_nm,
      updatedDate:
        listData[i].koshin_date && dateFormat(listData[i].koshin_date),
    });
  }
  //出力処理
  const { aoaToSheetXlsx } = await import("@/utils/export2Excel"); //lazy load
  aoaToSheetXlsx({
    data: list,
    headerMapper: Prop2LabelMap,
    filename: `${dayjs().format(
      DatePattern.SimpleDatePattern
    )}_問い合わせリスト.xlsx`,
    exclude: ["id"], //出力しない列
  });
}
